import UserBrowser from 'components/admin/Users/UserBrowser'
import UserDetails from 'components/admin/Users/UserDetails'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { destroy, initialize } from 'redux-form'
import { cancelConfirm, setDirtyFormState } from 'redux/navigation'
import { loadUsers } from 'redux/userAdmin'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { users = [], userSaving } = state.userAdmin
  return { users, userSaving }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadUsers,
      initialize,
      destroy,
      setDirtyFormState,
    },
    dispatch
  )
}

class UsersContainer extends React.Component {
  componentWillMount() {
    const {
      loadUsers,
      setDirtyFormState,
      users,
      match: {
        params: { user_id: userId },
      },
    } = this.props
    loadUsers()
    setDirtyFormState(false)
    if (users.length > 0 && userId) {
      this.initForm(userId, users)
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      users: oldUsers,
      userSaving: oldUserSaving,
      match: {
        params: { user_id: oldUserId },
      },
    } = this.props
    const {
      users: newUsers,
      userSaving: newUserSaving,
      match: {
        params: { user_id: newUserId },
      },
    } = nextProps

    if (
      oldUserId !== newUserId ||
      oldUsers.length !== newUsers.length ||
      (oldUserSaving && !newUserSaving)
    ) {
      this.initForm(newUserId, newUsers)
    }
  }

  initForm(userId, users) {
    const { initialize, destroy } = this.props
    if (userId === '+') {
      initialize('dealer_edit_form', {
        user_type: 'user',
        status: 'active',
      })
    } else if (userId) {
      const user = users.find((user) => user.id === Number(userId)) || {}
      const {
        id,
        address_number,
        status,
        prepayment,
        address1,
        address2,
        address3,
        address4,
        address5,
        address6,
        postcode,
        place,
        email,
        discount1,
        discount2,
        discount3,
        kind,
        payment_terms,
        addresses,
        logo_asset_id,
        assets = [],
        user_type,
        name,
        address_type,
        language,
        iban,
        vat_id,
        alternate_email,
        lat,
        lng,
        dealer_profit,
        maximum_discount,
        validated_bop,
        terms_asset_id
      } = user
      initialize('dealer_edit_form', {
        mediaIdList: assets.map((asset) => asset.id),
        id,
        address_number,
        status,
        prepayment,
        address1,
        address2,
        address3,
        address4,
        address5,
        address6,
        postcode,
        place,
        email,
        discount1,
        discount2,
        discount3,
        kind,
        payment_terms,
        addresses,
        logo_asset_id,
        user_type,
        name,
        address_type,
        language,
        iban,
        vat_id,
        alternate_email,
        lat,
        lng,
        dealer_profit,
        maximum_discount,
        validated_bop,
        terms_asset_id
      })
    } else {
      destroy('dealer_edit_form')
    }
  }

  render() {
    const {
      users,
      match: {
        params: { user_id },
      },
    } = this.props
    const user = users.find((user) => user.id === Number(user_id)) || {}
    return (
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}
            className="stacked top up-to-computer">
            <UserBrowser />
          </Grid.Column>
          <Grid.Column tablet={12} computer={12} largeScreen={8} widescreen={8}>
            <UserDetails form="dealer_edit_form" user={user} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

UsersContainer = connect(mapStateToProps, mapDispatchToProps)(UsersContainer)
export default UsersContainer



// WEBPACK FOOTER //
// ./src/containers/admin/users.jsx